module.exports = __webpack_public_path__ + "img/button_home.0174f5e2.svg";